module.exports = __webpack_public_path__ + "static/img/more-3.e530b507.png";